<template>
    <v-app toolbar>
        <v-navigation-drawer
            v-if="this.$store.state.authentication.loggedInUser"
            fixed
            app
            dark
            v-model="sideNav"
            mobile-break-point="1140"
            mini-variant.sync="false"
            class="nav-main"
        >
            <v-toolbar>
                <v-app-bar-nav-icon @click.stop="sideNav = !sideNav" color="white"></v-app-bar-nav-icon>
                <v-toolbar-title class="white--text">{{ this.$router.currentRoute.name }}</v-toolbar-title>
            </v-toolbar>
            <v-toolbar-title></v-toolbar-title>

            <v-list dense>
                <template v-for="item in toolbarItems">
                    <v-list-item :key="item.title" :to="item.link" :class="item.class">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.title" />
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar fixed app color="hubblue" v-if="this.$store.state.authentication.loggedInUser">
            <template v-if="!sideNav">
                <v-app-bar-nav-icon @click.stop="sideNav = !sideNav" color="white"></v-app-bar-nav-icon>
                <v-toolbar-title class="white--text">{{ this.$router.currentRoute.name }}</v-toolbar-title>
            </template>
            <v-spacer />
            <app-user-menu
                :user="this.$store.state.authentication.loggedInUser"
                :userMenuItems="userMenuItems"
            ></app-user-menu>
        </v-app-bar>

        <v-content>
            <router-view></router-view>
            <snackbar-widget-helper></snackbar-widget-helper>
        </v-content>

        <v-footer color="hubaccent2" padless>
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12 text-right>
                        <div class="white--text">&copy; {{ new Date().getFullYear() }} Survey Approver</div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-footer>
    </v-app>
</template>

<script>
import axios from 'axios'
import UserMenu from './components/Helpers/UserMenu.vue'

export default {
    components: {
        'app-user-menu': UserMenu
    },
    data() {
        return {
            sideNav: true,
            dashboardPath: '/dashboard'
        }
    },
    computed: {
        toolbarItems() {
            let toolbar = [{ title: 'Dashboard', link: '/dashboard' }]

            if (this.$store.getters.hasAdmin) {
                toolbar.push({ title: 'Initiate Approval', link: '/documents/create' })
            }

            return toolbar
        },
        userMenuItems() {
            let userMenuItems = [
                {
                    title: 'Edit User',
                    icon: 'mdi-account',
                    action: this.editUser
                },
                {
                    title: 'Change Password',
                    icon: 'mdi-lock-reset',
                    action: this.resetPassword
                }
            ]

            if (this.$store.getters.hasAdmin) {
                userMenuItems.push(
                    {
                        title: 'Email Lists',
                        icon: 'mdi-email',
                        action: this.emailList
                    },
                    {
                        title: 'Company Users',
                        icon: 'mdi-account-group',
                        action: this.manageCompanyUsers
                    },
                    {
                        title: 'Invite',
                        icon: 'mdi-account',
                        action: this.invite
                    }
                )
            }

            //log out should always be last
            userMenuItems.push(
                {
                    title: 'Feedback',
                    icon: 'mdi-message-text',
                    action: this.giveFeedback
                },
                {
                    title: 'Log Out',
                    icon: 'mdi-logout',
                    action: this.logout
                }
            )

            return userMenuItems
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        editUser() {
            this.$router.push({ name: 'Update User' })
        },
        emailList() {
            this.$router.push({ name: 'Distribution Lists' })
        },
        manageCompanyUsers() {
            this.$router.push({ name: 'Company Users' })
        },
        invite() {
            this.$router.push({ name: 'Invite' })
        },
        resetPassword() {
            this.$router.push({ name: 'Change Password' })
        },
        logout() {
            this.$store.state.authentication.logout
            this.$store.dispatch('authentication/logout')
            location.reload(true)
            this.$router.push('/')
        },
        giveFeedback() {
            this.$router.push({ name: 'Feedback' })
        }
    },
    created() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('controllerchange called!')
                if (this.refreshing) {
                    return
                }
                this.refreshing = true
                window.location.reload()
            })
        }
    }
}
</script>
